
import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from "recompose";
import { withCookies } from 'react-cookie';
import moment from 'moment';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import withStyles from '@material-ui/core/styles/withStyles';

import CustomizedSnackbars from './components/Common/CustomizedSnackbars';
import Homepage from './components/Homepage/App';
import LoginPage from './components/LoginPage/App';
import { history } from './_helpers';
import { userActions } from './_actions';

import './css/App.css';

const queryString = require('query-string');
const imageUrl = require(`./images/GameTheme/Background/Hell.png`)

const breakpointValues = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1500,
    xl: 1980,
};

const lightTheme = createMuiTheme({
    typography: {
        fontFamily: "\"Microsoft JhengHei\",\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        useNextVariants: true,
        fontSize: 15,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500
    },
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 3,
                border: 0,
                color: '#1b1b1b',
                height: 48,
                padding: '0 30px',
                boxShadow: '0 3px 5px 2px rgba(255, 255, 255, .3)',
            },
        },
        MuiTypography: {
            h4: {
                color: '#64b5f6'
            },
            h5: {
                color: '#006064'
            },
            h6: {
                color: '#455a64'
            },
            body1: {
                color: '#FF9800'
            },
            body2: {
                color: '#455a64'
            },
        }
    },
    palette: {
        type: 'light',
        primary: {
            main: '#fce4ec'
        },
        secondary: {
            main: '#f48fb1'
        },
    },
    breakpoints: { values: breakpointValues }
});

const darkTheme = createMuiTheme({
    typography: {
        fontFamily: "\"Microsoft JhengHei\",\"Roboto\", \"Helvetica\", \"Arial\", \"sans-serif\"",
        useNextVariants: true,
        fontSize: 15,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500
    },
    overrides: {
        MuiButton: {
            root: {
                borderRadius: 3,
                border: 0,
                color: '#FFFFFF',
                height: 48,
                padding: '0 30px',
                backgroundColor: '#303030'
            },
        },
    },
    MuiTypography: {
        h4: {
            color: '#64b5f6'
        },
        h5: {
            color: '#b2dfdb'
        },
        h6: {
            color: '#455a64'
        },
        body1: {
            color: '#FF9800'
        },
        body2: {
            color: '#455a64'
        },
    },
    palette: {
        type: 'dark',
        primary: {
            main: '#fce4ec'
        },
        secondary: {
            main: '#f48fb1'
        },
    },
    breakpoints: { values: breakpointValues }
});

const styles = theme => ({
    nonLoginPage: {
        height: '100vh',
    },
    loginPage: {
        height: '100vh',
        left: '-1445px',
        animation: 'example1 8s',
    },
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            snackbarOpen: false
        }

        if (props.user && props.user.id) {
            this.state = {
                isLogin: props.user ? props.user.status !== 'fail' ? true : false : false,
                openLoginPage: false,
            };
        }
        this.handleCallBack = this.handleCallBack.bind(this)
    }

    componentDidMount() {
        const parsed = queryString.parseUrl(window.location.href);

        if (parsed.query.AuthorizationToken && parsed.query.AuthorizationToken.length > 0) {
            this.props.dispatch(userActions.SSOlogin(parsed.query));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.user && nextProps.user.authorizationToken) {
            this.setState({
                isLogin: true,
            });
        }

        //PRODUCTION CHECK
        if (
            (nextProps.clients.token === false && nextProps.clients.token !== this.props.clients.token)
            || (nextProps.common.token === false && nextProps.common.token !== this.props.common.token)
            || (nextProps.departments.token === false && nextProps.departments.token !== this.props.departments.token)
            // || (nextProps.pipedrive.token === false && nextProps.pipedrive.token !== this.props.pipedrive.token)
            || (nextProps.projects.token === false && nextProps.projects.token !== this.props.projects.token)
            || (nextProps.tasksissues.token === false && nextProps.tasksissues.token !== this.props.tasksissues.token)
            || (nextProps.timesheet.token === false && nextProps.timesheet.token !== this.props.timesheet.token)
            || (nextProps.users.token === false && nextProps.users.token !== this.props.users.token)
        ) {

            this.setState({
                snackbarOpen: true,
            })

            this.handleSignoutClick()
        }
    }

    handleSubmitClick = () => {
        this.setState({
            isLogin: true
        });
    }

    handleSignoutClick = () => {
        require('./index.css')
        this.setState({
            isLogin: false,
            openLoginPage: false,
        });
        this.props.dispatch(userActions.logout());

        //PRODUCTION CHECK
        //window.location.replace('https://sso.ecloudvalley.com/login_ecv.html');
    }

    handleCallBack() {
        this.setState({
            openLoginPage: true,
        })
    }

    handleSnackBarClose = () => {
        this.setState({
            snackbarOpen: false
        })
    }

    render() {
        const { classes } = this.props;
        const checkedGameTheme = this.props.cookies.get('checkedGameTheme') === 'true' ? true : false || false;
        const checkedDarkTheme = this.props.cookies.get('checkedDarkTheme') === 'true' ? true : false || false;

        if (checkedDarkTheme) {
            document.body.style.background = 'rgb(48, 48, 48)';
            document.body.style.backgroundImage = 'radial-gradient(rgba(158, 206, 252, 0.1) 5%, transparent 0)';
        }
        else {
            document.body.style.background = 'rgb(250, 250, 250)';
            document.body.style.backgroundImage = 'radial-gradient(rgba(255, 205, 210, 0.5) 5%, transparent 0)';
        }

        document.body.style.backgroundSize = '60px 60px';

        if (!this.state.isLogin) {
            // document.body.style.background = 'rgba(75, 135, 182, 0.8)';
            // document.body.style.backgroundImage = 'radial-gradient(rgba(246, 185, 147, 0.8) 2%, transparent 0)';

            document.body.style.backgroundSize = 'auto';
            // document.body.style.backgroundImage = 'linear-gradient(135deg, rgba(126,198,201, .705), #917d7e)';
            document.body.style.backgroundImage = 'linear-gradient(155deg, rgba(239, 127, 58, .5), rgb(75, 135, 182))'
        }

        return (
            <Router history={history}>
                <MuiThemeProvider theme={checkedDarkTheme ? darkTheme : lightTheme} >
                    <CustomizedSnackbars open={this.state.snackbarOpen} close={this.handleSnackBarClose} snackbarMessage="Logout: Token Failed!" />
                    {checkedGameTheme && <img alt="background" src={imageUrl} className={this.state.openLoginPage || this.state.isLogin ? classes.loginPage : classes.nonLoginPage} style={{ position: 'fixed', zIndex: '-2' }} />}
                    {
                        this.state.isLogin
                            ?
                            <Homepage handleSignoutClick={this.handleSignoutClick} user={this.props.user} />
                            :
                            <LoginPage handleCallBack={this.handleCallBack} />
                    }
                </MuiThemeProvider>
            </Router>
        )
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { clients, common, departments, projects, tasksissues, timesheet, users } = state;

    return {
        user,
        clients,
        common,
        departments,
        projects,
        tasksissues,
        timesheet,
        users
    };
}

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(withCookies(App));


// WEBPACK FOOTER //
// ./src/App.js